import React,{Component} from "react";

// Assets
import UpArrow from "../../Assets/upArrow.svg";
import DownArrow from "../../Assets/downArrow.svg";

// ScheduleDiet Component
export default class ScheduleDiet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Hrs Timing
      hrs: 12,
      mins: 12,
    };
  }

  // Hours Change Logic Function timeType = 1 is for upper arrow & 2 is for down arrow
  hrsChange(arrowType,cnt,scheduleType) {
    let hrs = cnt;

    if(arrowType === 1) {

      if(hrs >= 1 && hrs <= 12) {
        hrs = hrs + 1;
        this.props.changeHr(hrs,scheduleType);
      } 
      if (hrs > 12) {
        hrs = 1; 
        this.props.changeHr(hrs,scheduleType);
      }
    } else {
      if(hrs >= 1 && hrs <= 12) {
        hrs = hrs - 1;
        this.props.changeHr(hrs,scheduleType);
      }
      if (hrs < 1) {
        hrs = 12; 
        this.props.changeHr(hrs,scheduleType);
      }
    }
  }

  // Minutes Change Logic Function timeType = 1 is for upper arrow & 2 is for down arrow
  minsChange(arrowType,cnt,scheduleType) {
    let mins = cnt;

    if(arrowType === 1) {

      if(mins >= 1 && mins <= 60) {
        mins = mins + 1;
        this.props.changeMin(mins,scheduleType);
      } 
      if (mins > 60) {
        mins = 1; 
        this.props.changeMin(mins,scheduleType);
      }
    } else {
      if(mins >= 1 && mins <= 60) {
        mins = mins - 1;
        this.props.changeMin(mins,scheduleType);
      }
      if (mins < 1) {
        mins = 60; 
        this.props.changeMin(mins,scheduleType);
      }
    }
  }

  // Diet Schedule Cards 
  scheduleCards(titleValue, scheduleType, timeValues) {
    return (
      <div className="Profile_SCCards">
        <div className="Profile_SCTitle">{titleValue}</div>
        <div className="Profile_SCTime">
          <div className="Profile_CTHrsButtons">
            <button
              className="UpArrow"
              style={{ backgroundImage: `url(${UpArrow})` }}
              onClick={() => this.hrsChange(1,timeValues.hrs,scheduleType)}
            ></button>
            <button
              className="DownArrow"
              style={{ backgroundImage: `url(${DownArrow})` }}
              onClick={() => this.hrsChange(2,timeValues.hrs,scheduleType)}
            ></button>
          </div>
          <div className="Hrs">{timeValues.hrs}</div>
          <div className="Profile_Seperator">
            <div className="dots"></div>
            <div className="dots"></div>
          </div>
          <div className="Mins">{timeValues.mins}</div>
          <div className="Profile_CTMinsButtons">
            <button
              className="UpArrow"
              style={{ backgroundImage: `url(${UpArrow})` }}
              onClick={() => this.minsChange(1,timeValues.mins,scheduleType)}
            ></button>
            <button
              className="DownArrow"
              style={{ backgroundImage: `url(${DownArrow})` }}
              onClick={() => this.minsChange(2,timeValues.mins,scheduleType)}
            ></button>
          </div>
        </div>
        <div className="Profile_SCMeridian">
          {titleValue === "Set Breakfast Timing" ? "AM" : "PM"}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="Profile_ScheduleDiet_Component">
        <div className="Profile_SDTitle">Diet Schedule Information</div>

        <div className="Profile_SDBlock">
          {this.scheduleCards("Set Breakfast Timing", 1, this.props.breakfastSchedule)}
          {this.scheduleCards("Set Lunch Timing", 2, this.props.lunchSchedule)}
          {this.scheduleCards("Set Dinner Timing", 3, this.props.dinnerSchedule)}
        </div>
      </div>
    );
  }
}
